// The search page's styles, taken from the conventions on the Match and
// Funding Requests pages so the two read as one app.

export const NAVY = '#1C3045'
export const NAVY_HOVER = '#162433'
export const NAVY_TINT = 'rgba(28, 48, 69, 0.04)'
export const BORDER = '#e0e0e0'
export const PANEL = '#f5f5f5'
export const FOCUS_BG = '#e8e8e8'
export const MUTED_TEXT = '#666'
export const ERROR_TEXT = '#D32F2F'
export const WARNING_BG = '#fff3cd'
export const WARNING_BORDER = '#ffe082'
export const WARNING_TEXT = '#856404'
export const PICKED_BG = '#e6eef8'
// Fundsorter's fluoro green. Navy text on it reads at about 11:1.
export const FLUORO = '#70FFA8'
export const FLUORO_HOVER = '#4ff492'

// Same visually-hidden styles as ScanStatusAnnouncer.
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const

export const searchButtonSx = {
  bgcolor: FLUORO,
  color: NAVY,
  textTransform: 'none',
  boxShadow: 'none',
  borderRadius: 2,
  fontSize: '16px',
  px: 3,
  py: 0.75,
  '&:hover': { bgcolor: FLUORO_HOVER, boxShadow: 'none' },
  '&.Mui-focusVisible': { outline: `2px solid ${NAVY}`, outlineOffset: 2 },
} as const

export const primaryButtonSx = {
  bgcolor: NAVY,
  color: 'white',
  textTransform: 'none',
  boxShadow: 'none',
  borderRadius: 2,
  fontSize: '14px',
  '&:hover': { bgcolor: NAVY_HOVER, boxShadow: 'none' },
  '&.Mui-focusVisible': { outline: `2px solid ${NAVY}`, outlineOffset: 2 },
} as const

export const secondaryButtonSx = {
  color: NAVY,
  borderColor: NAVY,
  textTransform: 'none',
  borderRadius: 2,
  fontSize: '14px',
  '&:hover': { borderColor: NAVY, bgcolor: NAVY_TINT },
  '&.Mui-focusVisible': { backgroundColor: FOCUS_BG },
} as const
